import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { NavigationEnd, Router } from '@angular/router';
import { Permission } from 'src/app/common/enums';
import { DateTime } from 'luxon';
import { filter } from 'rxjs';

@Component({
  selector: 'app-absence-main',
  templateUrl: './absence-main.component.html',
  styleUrl: './absence-main.component.scss',
  standalone: false
})
export class AbsenceMainComponent implements OnInit {
  private router = inject(Router);

  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;
  navigation = [
    {
      listType: AbsenceTabsType.AbsenceList,
      link: `absences/list/${DateTime.now().toFormat('yyyy')}`,
      linkTemplate: new RegExp('absences/list(?:/\\d{4})?$'),
      permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
    },
    {
      listType: AbsenceTabsType.AbsencePerYearList,
      link: `absences/${DateTime.now().toFormat('yyyy')}`,
      linkTemplate: new RegExp('(\\d{4})$'),
      permissions: [Permission.ViewMyAbsences, Permission.ViewWorkerAbsences, Permission.ViewAbsenceOnWorkerProfile, Permission.Supervisor],
    },
  ];

  constructor() { }

  ngOnInit(): void {
    this.setSelectedTabFromUrl(this.router.url);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.setSelectedTabFromUrl(event.url);
    });
  }

  private setSelectedTabFromUrl(url: string): void {
    let selectedIndex = 0;

    for (let i = 0; i < this.navigation.length; i++) {
      const navItem = this.navigation[i];

      if (navItem.listType === AbsenceTabsType.AbsenceList && navItem.linkTemplate && navItem.linkTemplate.test(url)) {
        selectedIndex = i;
        break;
      } else if (navItem.listType === AbsenceTabsType.AbsencePerYearList && navItem.linkTemplate && navItem.linkTemplate.test(url)) {
        selectedIndex = i;
        break;
      }
    }

    if (this.tabGroup) {
      this.tabGroup.selectedIndex = selectedIndex;
    }
  }

  onTabChanged(event: MatTabChangeEvent): void {
    const selectedTab = this.navigation[event.index];
    if (selectedTab) {
      this.router.navigateByUrl(selectedTab.link);
    }
  }
}

export enum AbsenceTabsType {
  AbsenceList = 'AbsenceList',
  AbsencePerYearList = 'AbsencePerYearList',
}